import React from "react";
import {Geography} from "react-simple-maps";
import {COLOR_ACTIVE, HOVER_COLOR, GeographyProps} from "../types";
import {Country, State} from "../../../../../features/countries/types";
import {StateStatistics} from "../../../../../features/statistics/types";
import {hoverTooltip} from "../hoverTooltip";
import theme from "../../../../../components/styles/theme/theme";

const COLOR_INACTIVE = theme.palette.primary["200"];

const renderGeographyForUSA = (
    geo: GeographyProps,
    handleCountrySelect: (geography: any) => () => void,
    selectedCountry?: Country,
    selectedState?: State,
    statesWithData?: string[],
    stateStatsMap?: Map<string, StateStatistics>,
) => {
    const {rsmKey, properties} = geo;
    if (!properties?.name) return null;
    const key = `${rsmKey}-${properties.name}`;
    const isSelected = !!selectedState && properties.name === selectedState.state_name;
    const hasData = !statesWithData || statesWithData.length === 0 || statesWithData.includes(properties.name);

    if (!hasData) {
        return (
            // @ts-ignore
            <Geography
                key={key}
                stroke={theme.palette.common.white}
                strokeWidth={0.2}
                geography={geo}
                style={{
                    default: {fill: COLOR_INACTIVE, outline: "none"},
                    hover: {fill: COLOR_INACTIVE, outline: "none", cursor: "default"},
                    pressed: {fill: COLOR_INACTIVE, outline: "none"},
                }}
            />
        );
    }

    const stateStat = stateStatsMap?.get(properties.name);
    const tooltipHtml = stateStat ? hoverTooltip(stateStat, properties.name) : null;

    return (
        // @ts-ignore
        <Geography
            key={key}
            stroke={theme.palette.common.white}
            strokeWidth={0.2}
            geography={geo}
            data-tooltip-html={tooltipHtml}
            data-tooltip-id={tooltipHtml ? "my-tooltip" : undefined}
            data-tooltip-offset={10}
            data-tooltip-place="right"
            style={{
                default: {fill: isSelected ? COLOR_ACTIVE : COLOR_INACTIVE, outline: "none"},
                hover: {fill: isSelected ? COLOR_ACTIVE : HOVER_COLOR, outline: "none", cursor: "pointer"},
                pressed: {fill: HOVER_COLOR, outline: "none"},
            }}
            onClick={handleCountrySelect(geo)}
        />
    );
};

export const renderGeographyForUSADistrict = (
    geo: GeographyProps,
    selectedDistrict?: string,
    onDistrictClick?: (districtId: string) => void,
) => {
    const {rsmKey, properties} = geo;
    if (!properties?.name) return null;
    const key = `${rsmKey}-${properties.name}`;
    // Normalize district ID: remove leading zeros, map at-large codes to "at-large"
    const rawDistrict = properties.district || '';
    const districtId = (rawDistrict === '98' || rawDistrict === '00')
        ? 'at-large'
        : rawDistrict ? String(parseInt(rawDistrict, 10)) : properties.name;
    const isSelected = !!selectedDistrict && districtId === selectedDistrict;

    return (
        // @ts-ignore
        <Geography
            key={key}
            stroke={theme.palette.common.white}
            strokeWidth={0.03}
            geography={geo}
            style={{
                default: {fill: isSelected ? COLOR_ACTIVE : COLOR_INACTIVE, outline: "none"},
                hover: {fill: isSelected ? COLOR_ACTIVE : HOVER_COLOR, outline: "none", cursor: "pointer"},
                pressed: {fill: HOVER_COLOR, outline: "none"},
            }}
            onClick={() => onDistrictClick?.(districtId)}
        />
    );
};

export default renderGeographyForUSA;
